import styled from 'styled-components';
import * as colors from '../../../../../../common/colorConstants';
import { mediumHeightScreens, smallScreens } from '../../../../../../common/fontElements';

export const StyledP = styled.p`
  color: ${colors.darkGray9};
  font-family: lato, sans-serif;
  line-height: 1.8rem;
  width: 100%;
  margin: 20px 0px 20px 10px;
  @media (max-height: ${smallScreens}) {
    font-size: 12px;
    margin: 10px 0px 10px 10px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    font-size: 11px;
    margin: 10px 0px 10px 10px;
  }
`;
